// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__aGn1Y","row":"Node_row__3rtl3","label":"Node_label__2VoiA","footer":"Node_footer__3Bp6D"};